import Header from '../Header';
import Footer from '../Footer';
import SkipToContent from '../SkipToContent';

import { StyledPageLayout } from './index.styled';

type PageLayoutProps = {
    children: React.ReactNode;
};

const PageLayout = ({ children }: PageLayoutProps) => (
    <>
        <SkipToContent />
        <Header />
        <StyledPageLayout id="#maincontent">{children}</StyledPageLayout>
        <Footer />
    </>
);

export default PageLayout;
